/**
 * The three type settings a Today card is made of. One string each, so the
 * cards cannot drift apart a tracking value at a time: before this, the page
 * carried nine eyebrow settings and five body sizes for what reads as one
 * surface. Colour is the caller's, because it depends on the ground the card
 * sits on.
 */

/** The card eyebrow: mono, text-2xs, regular, tracked. "Keeping an eye on". */
export const CARD_EYEBROW = "font-mono text-2xs uppercase tracking-[0.12em]";

/** Body copy: the Heartbeat timeline's setting. A reading, a reason, a detail. */
export const CARD_BODY = "font-sans text-sm font-normal leading-snug";

/** A row's title inside a card: the sense card's "move" line. */
export const CARD_ROW_TITLE = "font-sans text-base font-medium leading-snug";
